import _ from "lodash";
import { API_SERVER_URL, CLOUD_FUNCTIONS } from "../shared/config/constants";
import { writeException } from "../shared/services/LoggingService";
const { LOGGING } = CLOUD_FUNCTIONS;


export const getAllUserConnectors = async (currentUserId: string) => {
  try {
    const idToken = await getIdTokenFromLocalStorage();
    const response = await fetch(`${API_SERVER_URL}/user/connectors/${currentUserId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${idToken}`
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error('Failed to fetch connectors');
    }

    const data = await response?.json();
    return { isSucceed: true, result: data };
  } catch (error: any) {
    console.error('Error in getAllUserConnectors:', error);
    await writeException(`ErrorMessage: ${error.message}, UserID: ${currentUserId}`);
    return {
      isSucceed: false,
      errorMessage: error?.message || 'Failed to fetch user connectors'
    };
  }
};


export const getIdTokenFromLocalStorage = async (): Promise<string> => {
  const idToken = localStorage?.idToken ?? "";
  return idToken;
};

export const writeLog = async (
  type: string,
  message: string
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const idToken = await getIdTokenFromLocalStorage();
      let res = await fetch(`${API_SERVER_URL}/${LOGGING}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `${idToken}`
          },
          body: JSON.stringify({
            type: type,
            message: message
          }),
        });
      resolve({ isSucceed: true, message: '' });
    } catch (error: any) {
      console.error(error);
      reject(error);
      // await writeException(`ErrorMessage: ${error.message}`);      
    }
  });
}